<template>
<div class="chapter">
<div class="inner_page">
<div>
<h6 class="sigil_not_in_toc">Part One</h6>
<h2 id="toc_marker-1" title="Part One: Where Did All the Sexy Christians Go?">Where Did All the Sexy Christians Go?</h2>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// part1.vue?513ae744